export default "__VITE_ASSET__DiDrLP$t__"